import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FeedCard } from "@/components/feed/FeedCard";

// Página própria de uma publicação (ex.: só «Feed geral»): mesma audiência e permissões do feed; contexto de comentários = perfil/feed.
export default function PostPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const [item, setItem] = useState(null);
  const [state, setState] = useState("loading");
  useEffect(() => {
    setState("loading");
    Promise.all([api.get(`/profile/posts/${id}`), api.get("/profile-reactions/mine", { params: { post_ids: id } }).catch(() => ({ data: {} }))])
      .then(([r, m]) => {
        const p = r.data;
        const on_profile = !!p.destinations?.profile;
        setItem({ ...p, type: "profile", mine: m.data?.[id] ?? null, has_destinations: !p.destinations?.legacy,
                  source: { type: "profile", id: p.author.id, name: p.author.name, link: `/membro/${p.author.id}`, on_profile } });
        setState("ok");
      })
      .catch(() => setState("missing"));
  }, [id]);
  return (
    <div className="page max-w-2xl mx-auto px-4" data-testid="post-page">
      <div className="py-3"><Link to="/feed" className="text-xs text-zinc-500 inline-flex items-center gap-1" data-testid="post-page-back"><ChevronLeft size={14} /> Feed</Link></div>
      {state === "loading" && <div className="h-40 rounded-2xl bg-zinc-100 animate-pulse" />}
      {state === "missing" && <p className="text-sm text-zinc-500 italic text-center py-10" data-testid="post-page-missing">Publicação não disponível.</p>}
      {state === "ok" && item && <FeedCard item={item} user={user} onRemoved={() => setState("missing")} />}
    </div>
  );
}
